import { ReactNode } from "react";

export default function PoolsCard({
  children,
  title,
  description,
  bottom,
}: {
  children: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  bottom?: ReactNode;
}) {
  return (
    <div className="rounded-12 bg-gray-darker">
      <div className="flex flex-col px-14 py-16 sm:px-20">
        {title && <span className="text-body-large mb-8">{title}</span>}
        {description && <span className="text-body-medium mb-16 text-gray-lighter">{description}</span>}
        <div>{children}</div>
      </div>
      {bottom && <div className="pb-12">{bottom}</div>}
    </div>
  );
}
